var deliveryOptionsModule = (function (_app, _globalSettings, _dialog, _BaseView) {

    var _hiddenClass = 'hidden-block';

    var PackageView = Backbone.View.extend({

        events: {
            'click': '_select'
        },

        initialize: function () {
            _.bindAll(this, '_toggleSelected', '_select');
            this.$el = $.tmpl('deliveryOptionPackage', this.model.toJSON());
            this._toggleSelected();
            this.listenTo(this.model, 'change:Selected', this._toggleSelected);
        },

        _select: function (e) {
            e.stopPropagation();
            this.model.select();
        },

        _toggleSelected: function () {
            var isSelected = this.model.get('Selected');
            this.$el.toggleClass('radio-sw-item__selected', isSelected);
            this.$('@deliveryOption-package-icon').toggleClass('radio-sw-item-button_icon__selected', isSelected);
        }

    });

    var PackagesView = Backbone.View.extend({

        initialize: function () {
            _.bindAll(this, '_addOption');
            this._render();
            this.listenTo(this.collection, 'add', this._addOption);
        },

        _render: function () {
            this.collection.each(this._addOption);
        },

        _addOption: function (model) {
            var option = new PackageView({ model: model });
            this.$el.append(option.$el);
        }

    });

    var DeliveryOptionView = Backbone.View.extend({

        events: {
            'click': '_select',
            'click #OURPAYSELECTcheckbox': '_onTermsCheckboxClick',
            'click @ops-info-popup': '_display_ops_info_popup'
        },

        initialize: function () {
            _.bindAll(this, '_toggleSelected', '_select', '_togglePurchased', '_updatePrice', '_updateTitle', '_updateInfo', '_packagesReady', '_toggleAvailable', '_updateDescription');
            this.$el = $.tmpl('deliveryOptionContainer', this.model.toJSON());
            this._init();
            this.listenTo(this.model, 'change:Selected', this._toggleSelected);
            this.listenTo(this.model, 'change:Purchased', this._togglePurchased);
            this.listenTo(this.model, 'change:IsDeleted', this._toggle);
            this.listenTo(this.model, 'change:Price', this._updatePrice);
            this.listenTo(this.model, 'change:IsAvailable', this._toggleAvailable);
            this.listenTo(this.model, 'change:Description', this._updateDescription);
            this.listenTo(this.model, 'change:Info', this._updateInfo);
            this.listenTo(this.model, 'change:Title', this._updateTitle);
        },

        _init: function () {
            this.$el.html($.tmpl('deliveryOption', this.model.toJSON()));
            this.$deliveryOption_packages = this.$('@deliveryOption-packages');
            this.$deliveryOption_terms = this.$('@deliveryOption-terms-check-block');
            this._toggleSelected();
            this._toggleAvailable();
            this._renderPackages();
        },

        _updatePrice: function () {
            var price = this.model.get('Price');
            this.$('@delivery-option-price')
                .text(price > 0 && window.toMoney(price, _globalSettings.CurrencySign) || '');
        },

        _updateTitle: function () {
            var title = this.model.get('Title');
            this.$('@delivery-option-title').text(title || '');
        },

        _updateInfo: function () {
            var info = this.model.get('Info');
            this.$('@delivery-option-info').text(info || '');
        },

        _renderPackages: function () {
            !this.model.get('Purchased') &&
                this.model.get('Packages') !== null &&
                new PackagesView({ el: this.$deliveryOption_packages, collection: this.model.get('Packages') });
            this.$('@ops-info-popup').toggleClass(_hiddenClass, this.model.get('Purchased') || false);
        },

        _select: function (e) {
            e.stopPropagation();
            var isAvailable = this.model.get('IsAvailable');
            if (isAvailable) {
                _app && _app.event && _app.event.chooseDeliveryOption(this.model.get('Name'));
                this.model.select();
            }
        },

        _toggleSelected: function () {
            var isSelected = this.model.get('Selected');
            this.$el.toggleClass('radio-sw-item__selected', isSelected);
            this.$('@deliveryOption-icon').toggleClass('radio-sw-item-button_icon__selected', isSelected);
            this.$deliveryOption_packages.toggleClass(_hiddenClass, !isSelected);
            this.$deliveryOption_terms.toggleClass(_hiddenClass, !isSelected || this.model.get('Purchased'));
        },

        _togglePurchased: function () {
            if (this.model.get('Purchased')) {
                this._init();
            }
        },

        _toggleAvailable: function () {
            var isAvailable = this.model.get('IsAvailable');
            this.$el.toggleClass('radio-sw-disabled', !isAvailable);
        },

        _updateDescription: function () {
            this.$('@DeliveryOptionDescription').text(this.model.get('Description'));
        },

        _toggle: function () {
            var isOptionHidden = this.model.get('IsDeleted') || !this.model.get('IsVisible');
            this.$el.toggleClass(_hiddenClass, isOptionHidden);
        },

        _onTermsCheckboxClick: function (e) {
            e.stopPropagation();
            this.model.set('AgreedWithTerms', e.currentTarget.checked);
        },

        _display_ops_info_popup: function (e) {
            e.stopPropagation();
            _app && _app.event && _app.event.selectMoreDetails();
            this.model.get('Packages').ready(this._packagesReady);
        },

        _packagesReady: function() {
            this.dialog && this.dialog.destroy();
            this.dialog = _dialog.popup({
                closeBtn: false,
                hideOnClick: false
            });

            this.dialog.$('.notifier-inner')
                .empty()
                .css({ 'background': 'none', 'background-color': '#fff', 'padding': '0', 'max-width': '900px' })
                .append($.tmpl('ops-info', { packages: this.model.get('Packages').map(function (m) { return m.toJSON(); }) }));

            this.dialog.$el.css({ 'marginTop': '-200px' });
        }

    });

    var DeliveryOptionsView = _BaseView.extend({
        initialize: function () {
            _.bindAll(this, '_addOption', '_toggle');

            this.$el = $.tmpl('deliveryOptions');

            this.onChangeDeliverySectionMode(this._toggle);
            this._toggle();

            $('@delivery-options').replaceWith(this.$el);

            this._render();

            this.listenTo(this.collection, 'add', this._addOption);
        },

        _render: function () {
            this.collection.each(this._addOption);
        },

        _addOption: function (model) {
            var option = new DeliveryOptionView({ model: model });
            this.$el.append(option.$el);
            option._toggle();
        },

        _switchFormMode: function (e, mode) {
            mode = mode || this.getDeliverySectionMode();
            this.$el.toggleClass(hiddenClass, mode === this.deliverySectionMode.embeddedLogin || !(this.collection.length > 1));
        },

        _toggle: function (e, mode) {
            mode = mode || this.getDeliverySectionMode();
            var isEmbeddedLogin = mode === this.deliverySectionMode.embeddedLogin;
            var isCollectionHidden = this.collection.length <= 1 || this.collection.where({IsVisible : true}).length <= 1;
            this.$el.toggleClass(_hiddenClass, isCollectionHidden || isEmbeddedLogin);
        }
    });

    return new DeliveryOptionsView({ collection: _app.models.delivery.options }); 

});